import React, { useEffect, useState } from 'react';
import { FaHandHoldingHeart, FaHandsHelping } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { getPublicKafalaStats } from '../services/kafalaService';
import './KafalaImpactStats.css';

const KafalaImpactStats = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState({ waiting: 0, sponsored: 0 });

  useEffect(() => {
    getPublicKafalaStats()
      .then((data) => {
        setStats({
          waiting: Number(data?.waiting) || 0,
          sponsored: Number(data?.sponsored) || 0,
        });
      })
      .catch(() => {});
  }, []);

  const items = [
    { key: 'sponsored', title: t('public.kafalaImpact.sponsored'), value: stats.sponsored, Icon: FaHandsHelping },
    { key: 'waiting', title: t('public.kafalaImpact.waiting'), value: stats.waiting, Icon: FaHandHoldingHeart },
  ];

  return (
    <section className="kafala-impact" aria-label={t('public.kafalaImpact.label')}>
      <div className="kafala-impact__curve" />
      <div className="kafala-impact__row">
        {items.map(({ key, title, value, Icon }) => (
          <article key={key} className="kafala-impact__item">
            <div className="kafala-impact__icon">
              <Icon />
            </div>
            <h3>{title}</h3>
            <p>{value}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default KafalaImpactStats;
